import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useTranslation } from 'react-i18next'
import "./AlertMessageRequestProduct.css"

const AlertMessageRequestProduct = () => {
    const { t } = useTranslation()
    return (
        <div className="con-alert-msg-product color-alert flex flex-ai-center">
            <FontAwesomeIcon icon={faMagnifyingGlass} className="color-alert fs-20-vh" />
            <p className="fs-20-vh ml-20">{t("ManageProducts:request:label_04")}</p>
        </div>
    )
}

export default React.memo( AlertMessageRequestProduct )